<template>
  <div
    class="audit-container"
    @touchstart="touchStart"
    @touchend="touchEnd"
  >
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>风险内容审核</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 审核卡片 -->
    <el-card class="audit-card">
      <div slot="header">
        <span>风险数据审核</span>
      </div>

      <div class="audit-content">
        <p class="audit-text"><strong>问题ID：</strong>{{ currentData.issueId }}</p>
        <p class="audit-text"><strong>消息内容：</strong>{{ currentData.msgContent }}</p>
        <p class="audit-text">
          <strong>发送人：</strong>
          <el-link type="primary" @click="openChatDialog(currentData.senderUserId)">
            {{ currentData.senderUserId }}
          </el-link>
        </p>
        <p class="audit-text"><strong>发送时间：</strong>{{currentData.createTime|timestampToTime}}</p>

      </div>

      <!-- 操作按钮 -->
      <div class="audit-actions">
        <el-button type="danger" @click="handleAction('ban',currentData.senderUserId,0)">封禁</el-button>
        <el-button type="success" @click="handleAction('processed',0,currentData.issueId)">已处理</el-button>
      </div>
    </el-card>

    <!-- 聊天弹框 -->
    <el-dialog title="聊天记录" :visible.sync="imgsVisiable">
      <el-table :data="userImgs">
        <el-table-column property="receiverId" label="接收者"></el-table-column>
        <el-table-column property="payload" label="内容"></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleImgsCurrentChange"
        :current-page.sync="imPageIndex"
        :page-size="imPageSize"
        :total="userImgsTotal">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import {
  banUserById,
  getImgsBySenderId,
  getMsgIssue,
  setIssueDone
} from '../../api/userMG'

export default {
  name: "AuditModule",
  data() {
    return {
      currentData: {},
      chatDialogVisible: false,
      chatList: [],
      isMobile: false,
      touchStartY: 0,
      touchEndY: 0,
      imPageIndex:1,
      imPageSize:20,
      imgsUserId:'',
      userImgs:[],
      userImgsTotal:0,
      imgsVisiable: false
    };
  },
  mounted() {
    this.checkDevice();
    this.loadNextData()
    window.addEventListener("resize", this.checkDevice);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkDevice);
  },
  methods: {
    checkDevice() {
      this.isMobile = window.innerWidth <= 768;
    },
    openChatDialog(userId) {
      let _this = this
      _this.imgsUserId = userId
      _this.imPageIndex = 1
      getImgsBySenderId({'userId': userId, 'pageIndex': _this.imPageIndex, 'pageSize': _this.imPageSize}).then(res=>{
        this.imgsVisiable = true
        this.userImgs = res.data.list
        this.userImgsTotal = res.data.total
      })
    },
    handleImgsCurrentChange(val){
      this.imPageIndex = val
      let _this = this
      getImgsBySenderId({'userId': _this.imgsUserId, 'pageIndex': _this.imPageIndex, 'pageSize': _this.imPageSize}).then(res=>{
        this.imgsVisiable = true
        this.userImgs = res.data.list
        this.userImgsTotal = res.data.total
      })
    },
    handleAction(action, userId, issueId) {
      if (action === "ban") {
        // console.log(userId)
        banUserById({'banUserId': userId}).then(res=>{
          this.$message({
            type: 'info',
            message: res.msg+"删除"+res.data+"条记录"
          })
        })
      } else if (action === "processed") {
        setIssueDone({"issueId":issueId}).then(res=>{
          this.$message({
            type: 'info',
            message: res.msg
          })
          this.loadNextData();
        })
      }
    },
    loadNextData() {
      let _this = this
      getMsgIssue().then(res=>{
        if(res.code == "200"){
          if(res.data == "" || res.data==undefined){
            this.$message({
              type: 'info',
              message: '暂无数据'
            })
          }else{
            _this.currentData = res.data
          }
        }
      })
    },
    // 上下滑切换消息
    touchStart(e) {
      this.touchStartY = e.changedTouches[0].screenY;
    },
    touchEnd(e) {
      this.touchEndY = e.changedTouches[0].screenY;
      if (this.touchStartY - this.touchEndY > 80) {
        // 上滑 → 下一条
        this.loadNextData();
      } else if (this.touchEndY - this.touchStartY > 80) {
        // 下滑 → 上一条（此处可以接入接口）
        this.$message.info("上一条（示例，可扩展）");
      }
    },
  },
};
</script>

<style scoped>
.audit-container {
  padding: 16px;
}

.audit-card {
  margin-top: 50px;
  border-radius: 12px;
  overflow: hidden;
}

.audit-content {
  margin-bottom: 20px;
  line-height: 1.6;
}

.audit-text {
  font-size: 16px;
  margin-bottom: 12px;
}

/* 操作按钮 PC 默认横排 */
.audit-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* 移动端优化 */
@media (max-width: 768px) {
  .audit-text {
    font-size: 14px;
  }
  .audit-actions {
    flex-direction: column;
    align-items: stretch;
    margin-top: 20px;
  }
  .audit-actions .el-button {
    width: 100%;
    font-size: 16px;
    padding: 14px;
    border-radius: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/sensitiveCheck.vue